
export default {
    name: 'SecurityFeatures',
    props: {
        cta: {
            default: 'outline'
        }
    }
}
